<script>
import BaseWidgetForm from './BaseWidgetForm'
import fields from '@/components/fields/'

export default {
  extends: BaseWidgetForm,
  data() {
    return {
      arrayFields: ['agencies', 'clients', 'opinions']
    }
  },
  computed: {
    tabsFieldsSchema() {
      return [
        {
          label: 'Ogólne',
          fields: [
            ...this.getCommonFields(),
            new fields.Input({
              label: 'Tytuł',
              modelPath: [this, 'form', 'title'],
              multilingual: true,
              required: true
            }),
            new fields.Formset({
              modelPath: [this, 'form', 'opinions'],
              sectionName: 'Opinions: ',
              required: true,
              items: this.form.opinions.map((_, i) => {
                return {
                  headerLabel: i,
                  fields: [
                    new fields.Image({
                      label: 'Zdjęcie',
                      modelPath: [this, 'form', 'opinions', i, 'image'],
                      multilingual: false
                    }),
                    new fields.Input({
                      label: 'Autor',
                      modelPath: [this, 'form', 'opinions', i, 'author'],
                      multilingual: false,
                      required: true
                    }),
                    new fields.Input({
                      label: 'Stanowisko',
                      modelPath: [this, 'form', 'opinions', i, 'position'],
                      multilingual: true,
                      required: true
                    }),
                    new fields.Input({
                      label: 'Wypowiedź',
                      modelPath: [this, 'form', 'opinions', i, 'statement'],
                      multilingual: true,
                      required: true
                    })
                  ]
                }
              })
            }),
            new fields.Formset({
              sectionName: 'Agencies: ',
              modelPath: [this, 'form', 'agencies'],
              required: true,
              items: this.form.agencies.map((item, i) => {
                return {
                  headerLabel: i,
                  fields: [
                    new fields.Image({
                      label: 'Zdjęcie',
                      modelPath: [this, 'form', 'agencies', i, 'image'],
                      multilingual: false
                    })
                  ]
                }
              })
            }),
            new fields.Formset({
              sectionName: 'Clients: ',
              modelPath: [this, 'form', 'clients'],
              required: true,
              items: this.form.clients.map((item, i) => {
                return {
                  headerLabel: i,
                  fields: [
                    new fields.Image({
                      label: 'Zdjęcie',
                      modelPath: [this, 'form', 'clients', i, 'image'],
                      multilingual: false
                    })
                  ]
                }
              })
            })
          ]
        }
      ]
    }
  },
  methods: {}
}
</script>
